import { encodeWhatsappShareText } from 'utils/whatsappShareUrl';

/** מספר המכירות שאליו מגיעות הפניות מדף "מה חדש" — בפורמט בינלאומי בלי + */
export const SALES_WHATSAPP_PHONE = '972508313310';

const openWhatsapp = (text: string): void => {
    const url = `https://api.whatsapp.com/send?phone=${SALES_WHATSAPP_PHONE}&text=${encodeWhatsappShareText(text)}`;
    window.open(url, '_blank')?.focus();
};

export const openFeatureContact = (featureTitle: string): void => {
    openWhatsapp(`שלום, אני רוצה לשמוע פרטים על הפיצ'ר: ${featureTitle}`);
};

export const openGeneralContact = (): void => {
    openWhatsapp('שלום, אני רוצה לשמוע על היכולות החדשות בניהול קו');
};
